<template>
    <div class="p-4">
        <!-- 系統時間設定 -->
        <div class="card mb-4">
            <div class="card-header bg-light">
                <h4 class="mb-0 font-weight-bold">開發測試用設定</h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <div class="mb-3">
                            <label class="form-label">改變系統當前日期 ({{ $shared.getCurrentDate() }})</label>
                            <input class="form-control" type="date" v-model="setting.date" />
                        </div>

                        <div class="mb-3">
                            <label class="form-label">改變系統當前時間 ({{ $shared.getCurrentDateTime() }})</label>
                            <input class="form-control" type="time" v-model="setting.time" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button class="btn btn-primary me-2" @click="save">儲存設定</button>
                        <button class="btn btn-outline-secondary" @click="closeSetting">清除設定</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 1. Abacus Vet5 (血液血球檢驗, ID: 1) -->
        <div class="card mb-4">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0 font-weight-bold text-primary">Abacus Vet5 (血液血球檢驗 - Device ID: 1)</h5>
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3 col-sm-6 col-12">
                        <label class="form-label font-weight-bold">病歷編號</label>
                        <input class="form-control" type="text" placeholder="請輸入病歷編號" v-model="medical_record_sn" />
                    </div>
                </div>
                <div class="row g-2">
                    <div class="col-lg-1 col-md-2 col-sm-3 col-4" v-for="(val, key) in abacus_Vet5" :key="key">
                        <div class="mb-2">
                            <label class="form-label small text-muted mb-1">{{ key }}</label>
                            <input class="form-control form-control-sm" type="number" step="any" v-model.number="abacus_Vet5[key]" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <button class="btn btn-success" @click="saveAbacusVet5">儲存並上傳 Abacus Vet5</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 2. IDEXX ProCyte Dx (血液血球檢驗, ID: 4) -->
        <div class="card mb-4">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0 font-weight-bold text-primary">IDEXX ProCyte Dx (血液血球檢驗 - Device ID: 4)</h5>
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3 col-sm-6 col-12">
                        <label class="form-label font-weight-bold">病歷編號</label>
                        <input class="form-control" type="text" placeholder="請輸入病歷編號" v-model="medical_record_sn" />
                    </div>
                </div>
                <div class="row g-2">
                    <div class="col-lg-1 col-md-2 col-sm-3 col-4" v-for="(val, key) in IDEXX_ProCyteDx" :key="key">
                        <div class="mb-2">
                            <label class="form-label small text-muted mb-1">{{ key }}</label>
                            <input class="form-control form-control-sm" type="number" step="any" v-model.number="IDEXX_ProCyteDx[key]" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <button class="btn btn-success" @click="saveIDEXX_ProCyteDx">儲存並上傳 IDEXX ProCyte Dx</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3. Abasix VetScan V2 (血液生化檢驗, ID: 2) -->
        <div class="card mb-4">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0 font-weight-bold text-success">Abasix VetScan V2 (血液生化檢驗 - Device ID: 2)</h5>
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3 col-sm-6 col-12">
                        <label class="form-label font-weight-bold">病歷編號</label>
                        <input class="form-control" type="text" placeholder="請輸入病歷編號" v-model="medical_record_sn" />
                    </div>
                </div>
                <div class="row g-2">
                    <div class="col-lg-1 col-md-2 col-sm-3 col-4" v-for="(val, key) in abasixVetScanV2" :key="key">
                        <div class="mb-2">
                            <label class="form-label small text-muted mb-1">{{ key }}</label>
                            <input class="form-control form-control-sm" type="number" step="any" v-model.number="abasixVetScanV2[key]" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <button class="btn btn-success" @click="saveAbasixVetScanV2">儲存並上傳 Abasix VetScan V2</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 4. IDEXX Catalyst One (血液生化檢驗, ID: 3) -->
        <div class="card mb-4">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0 font-weight-bold text-success">IDEXX Catalyst One (血液生化檢驗 - Device ID: 3)</h5>
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3 col-sm-6 col-12">
                        <label class="form-label font-weight-bold">病歷編號</label>
                        <input class="form-control" type="text" placeholder="請輸入病歷編號" v-model="medical_record_sn" />
                    </div>
                </div>
                <div class="row g-2">
                    <div class="col-lg-1 col-md-2 col-sm-3 col-4" v-for="(val, key) in IDEXX_CatalystOne" :key="key">
                        <div class="mb-2">
                            <label class="form-label small text-muted mb-1">{{ key }}</label>
                            <input class="form-control form-control-sm" type="number" step="any" v-model.number="IDEXX_CatalystOne[key]" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <button class="btn btn-success" @click="saveIDEXX_CatalystOne">儲存並上傳 IDEXX Catalyst One</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 5. X-Ray (X光檢驗, ID: 8) -->
        <div class="card mb-4">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0 font-weight-bold text-dark">X-Ray (X光檢驗 - Device ID: 8)</h5>
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3 col-sm-6 col-12">
                        <label class="form-label font-weight-bold">病歷編號</label>
                        <input class="form-control" type="text" placeholder="請輸入病歷編號" v-model="medical_record_sn" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-12">
                        <div class="mb-3">
                            <label class="form-label">X-Ray DICOM 檔案 (.dcm)</label>
                            <input class="form-control" type="file" @change="handleXRayFileUpload" accept=".dcm" />
                            <div v-if="uploadedFileName" class="text-success small mt-1 font-weight-bold">
                                已選檔案: {{ uploadedFileName }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <button class="btn btn-success" @click="saveXRay">儲存並上傳 X-Ray</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dev-setting-view',
    data() {
        return {
            setting: {
                date: null,
                time: null
            },
            medical_record_sn: '',

            // 1. Abacus Vet5 (exam_type: 1, exam_device_id: 1)
            abacus_Vet5: {
                WBC: 0,
                LYM: 0,
                MON: 0,
                NEU: 0,
                EOS: 0,
                BAS: 0,
                'LYM%': 0,
                'MON%': 0,
                'NEU%': 0,
                'BAS%': 0,
                RBC: 0,
                HGB: 0,
                HCT: 0,
                MCV: 0,
                MCH: 0,
                MCHC: 0,
                RDWc: 0,
                RDWs: 0,
                PLT: 0,
                MPV: 0,
                PCT: 0,
                PDWc: 0,
                PDWs: 0
            },

            // 2. IDEXX ProCyte Dx (exam_type: 1, exam_device_id: 4)
            IDEXX_ProCyteDx: {
                RBC: 0,
                HCT: 0,
                HGB: 0,
                MCV: 0,
                MCH: 0,
                MCHC: 0,
                RDW: 0,
                '%RETIC': 0,
                RETIC: 0,
                WBC: 0,
                '%NEU': 0,
                '%LYM': 0,
                '%MONO': 0,
                '%EOS': 0,
                '%BASO': 0,
                NEU: 0,
                LYM: 0,
                MONO: 0,
                EOS: 0,
                BASO: 0,
                PLT: 0,
                MPV: 0,
                PDW: 0,
                PCT: 0
            },

            // 3. Abasix VetScan V2 (exam_type: 2, exam_device_id: 2)
            abasixVetScanV2: {
                AST: 0,
                BA: 0,
                TP: 0,
                ALB: 0,
                GLOB: 0,
                CA: 0,
                PHOS: 0,
                GLU: 0,
                CK: 0,
                UA: 0,
                'NA+': 0,
                'K+': 0,
                BUN: 0,
                CRE: 0,
                ALT: 0,
                TBIL: 0,
                tCO2: 0,
                'CL-': 0,
                ALP: 0
            },

            // 4. IDEXX Catalyst One (exam_type: 2, exam_device_id: 3)
            IDEXX_CatalystOne: {
                GLU: 0,
                CREA: 0,
                BUN: 0,
                'BUN/CREA': 0,
                PHOS: 0,
                CA: 0,
                TP: 0,
                ALB: 0,
                GLOB: 0,
                'ALB/GLOB': 0,
                ALT: 0,
                ALKP: 0,
                GGT: 0,
                TBIL: 0,
                CHOL: 0,
                AST: 0,
                LDH: 0,
                CK: 0,
                'NA+': 0,
                'K+': 0,
                'Na/K': 0,
                'CL-': 0,
                LAC: 0,
                TRIG: 0,
                'Osm Calc': 0,
                NH3: 0,
                'URIC(UA)': 0,
                Mg: 0,
                PT: 0,
                aPTT: 0
            },

            uploadedFileName: '',
            uploadedFilePath: []
        };
    },
    methods: {
        /**
         * 儲存日期時間設定至 localStorage
         */
        save() {
            try {
                localStorage.setItem('wildone_dev_setting', JSON.stringify(this.setting));
                this.$store.state.actionResult.show({ status: 'success', massage: '日期時間設定已儲存' });
            } catch (error) {
                console.error('[devSetting] 儲存時間設定失敗:', error);
            }
        },

        /**
         * 清除日期時間設定
         */
        closeSetting() {
            try {
                this.setting = {
                    date: null,
                    time: null
                };
                localStorage.removeItem('wildone_dev_setting');
                this.$store.state.actionResult.show({ status: 'success', massage: '設定已清除' });
            } catch (error) {
                console.error('[devSetting] 清除時間設定失敗:', error);
            }
        },

        /**
         * 儲存並上傳 Abacus Vet5 (Device ID: 1, Type: 1)
         * @returns {Promise<void>}
         */
        async saveAbacusVet5() {
            try {
                if (!this.medical_record_sn) {
                    return alert('請輸入病歷編號');
                }
                const objFrom = new FormData();
                objFrom.append('medical_record_sn', this.medical_record_sn);
                objFrom.append('exam_type', 1);
                objFrom.append('exam_device_id', 1);
                objFrom.append('exam_result', JSON.stringify(this.abacus_Vet5));

                this.$store.state.loadingStatus = true;
                const res = await this.$api.exam.updInsideExamFile(objFrom);
                this.$store.state.loadingStatus = false;
                if (res.code !== 200) {
                    this.$store.state.actionResult.show({ status: 'fail', massage: res.msg });
                    return;
                }
                this.$store.state.actionResult.show({ status: 'success', massage: 'Abacus Vet5 上傳成功' });
            } catch (error) {
                this.$store.state.loadingStatus = false;
                console.error('[devSetting] saveAbacusVet5 錯誤:', error);
            }
        },

        /**
         * 儲存並上傳 IDEXX ProCyte Dx (Device ID: 4, Type: 1)
         * @returns {Promise<void>}
         */
        async saveIDEXX_ProCyteDx() {
            try {
                if (!this.medical_record_sn) {
                    return alert('請輸入病歷編號');
                }
                const objFrom = new FormData();
                objFrom.append('medical_record_sn', this.medical_record_sn);
                objFrom.append('exam_type', 1);
                objFrom.append('exam_device_id', 4);
                objFrom.append('exam_result', JSON.stringify(this.IDEXX_ProCyteDx));

                this.$store.state.loadingStatus = true;
                const res = await this.$api.exam.updInsideExamFile(objFrom);
                this.$store.state.loadingStatus = false;
                if (res.code !== 200) {
                    this.$store.state.actionResult.show({ status: 'fail', massage: res.msg });
                    return;
                }
                this.$store.state.actionResult.show({ status: 'success', massage: 'IDEXX ProCyte Dx 上傳成功' });
            } catch (error) {
                this.$store.state.loadingStatus = false;
                console.error('[devSetting] saveIDEXX_ProCyteDx 錯誤:', error);
            }
        },

        /**
         * 儲存並上傳 Abasix VetScan V2 (Device ID: 2, Type: 2)
         * @returns {Promise<void>}
         */
        async saveAbasixVetScanV2() {
            try {
                if (!this.medical_record_sn) {
                    return alert('請輸入病歷編號');
                }
                const objFrom = new FormData();
                objFrom.append('medical_record_sn', this.medical_record_sn);
                objFrom.append('exam_type', 2);
                objFrom.append('exam_device_id', 2);
                objFrom.append('exam_result', JSON.stringify(this.abasixVetScanV2));

                this.$store.state.loadingStatus = true;
                const res = await this.$api.exam.updInsideExamFile(objFrom);
                this.$store.state.loadingStatus = false;
                if (res.code !== 200) {
                    this.$store.state.actionResult.show({ status: 'fail', massage: res.msg });
                    return;
                }
                this.$store.state.actionResult.show({ status: 'success', massage: 'Abasix VetScan V2 上傳成功' });
            } catch (error) {
                this.$store.state.loadingStatus = false;
                console.error('[devSetting] saveAbasixVetScanV2 錯誤:', error);
            }
        },

        /**
         * 儲存並上傳 IDEXX Catalyst One (Device ID: 3, Type: 2)
         * @returns {Promise<void>}
         */
        async saveIDEXX_CatalystOne() {
            try {
                if (!this.medical_record_sn) {
                    return alert('請輸入病歷編號');
                }
                const objFrom = new FormData();
                objFrom.append('medical_record_sn', this.medical_record_sn);
                objFrom.append('exam_type', 2);
                objFrom.append('exam_device_id', 3);
                objFrom.append('exam_result', JSON.stringify(this.IDEXX_CatalystOne));

                this.$store.state.loadingStatus = true;
                const res = await this.$api.exam.updInsideExamFile(objFrom);
                this.$store.state.loadingStatus = false;
                if (res.code !== 200) {
                    this.$store.state.actionResult.show({ status: 'fail', massage: res.msg });
                    return;
                }
                this.$store.state.actionResult.show({ status: 'success', massage: 'IDEXX Catalyst One 上傳成功' });
            } catch (error) {
                this.$store.state.loadingStatus = false;
                console.error('[devSetting] saveIDEXX_CatalystOne 錯誤:', error);
            }
        },

        /**
         * 處理 X-Ray DICOM 檔案選擇與上傳
         * @param {Event} event
         * @returns {Promise<void>}
         */
        async handleXRayFileUpload(event) {
            try {
                const file = event.target.files[0];
                if (file && this.isValidDcmFile(file)) {
                    this.uploadedFileName = file.name;
                } else {
                    alert('只能上傳 .dcm 檔案!');
                    event.target.value = '';
                    this.uploadedFileName = '';
                    return;
                }

                const objFrom = new FormData();
                objFrom.append('files', file);
                this.$store.state.loadingStatus = true;
                const res = await this.$api.files.uploadFiles(objFrom, (progress) => {
                    this.$debug('progress:', progress);
                });
                this.$store.state.loadingStatus = false;
                if (res.code !== 200) {
                    this.$store.state.actionResult.show({ status: 'fail', massage: res.msg });
                    return;
                }

                this.uploadedFilePath[0] = res.data.imgPath;
                event.target.value = '';
            } catch (error) {
                this.$store.state.loadingStatus = false;
                console.error('[devSetting] handleXRayFileUpload 錯誤:', error);
            }
        },

        /**
         * 儲存並上傳 X-Ray (Device ID: 8, Type: 8)
         * @returns {Promise<void>}
         */
        async saveXRay() {
            try {
                if (!this.medical_record_sn) {
                    return alert('請輸入病歷編號');
                }
                if (this.uploadedFilePath.length <= 0) {
                    return alert('請先上傳 .dcm 檔案');
                }

                const objFrom = new FormData();
                objFrom.append('medical_record_sn', this.medical_record_sn);
                objFrom.append('exam_type', 8);
                objFrom.append('exam_device_id', 8);
                const result_file_url = JSON.stringify([{ imgPath: this.uploadedFilePath[0], json: {} }]);
                objFrom.append('result_file_url', result_file_url);

                this.$store.state.loadingStatus = true;
                const res = await this.$api.exam.updInsideExamFile(objFrom);
                this.$store.state.loadingStatus = false;
                if (res.code !== 200) {
                    this.$store.state.actionResult.show({ status: 'fail', massage: res.msg });
                    return;
                }
                this.$store.state.actionResult.show({ status: 'success', massage: 'X-Ray 上傳成功' });
            } catch (error) {
                this.$store.state.loadingStatus = false;
                console.error('[devSetting] saveXRay 錯誤:', error);
            }
        },

        /**
         * 驗證檔案副檔名是否為 .dcm
         * @param {File} file
         * @returns {boolean}
         */
        isValidDcmFile(file) {
            const fileName = file.name.toLowerCase();
            return fileName.endsWith('.dcm');
        }
    },
    created() {
        try {
            const setting = localStorage.getItem('wildone_dev_setting');
            this.setting = setting
                ? JSON.parse(setting)
                : {
                      date: null,
                      time: null
                  };
        } catch (error) {
            console.error('[devSetting] 讀取設定失敗:', error);
        }
    }
};
</script>

<style scoped>
</style>